import { JSX } from 'react';

const IconChevronDown = (): JSX.Element => {
  return (
    <>
      <path
        d="M23,6.5l-11,11L1,6.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </>
  );
};

export default IconChevronDown;
